export interface VoiceTranscript {
  id: string;
  text: string;
}

export const VoiceTranscriptEntity = {
  create(input: { text: string; transcriptionId: string }): VoiceTranscript {
    return {
      id: input.transcriptionId,
      text: input.text,
    };
  },

  matchesTranscriptionEvent(
    transcript: VoiceTranscript | null,
    event: { transcriptionId: string },
  ): boolean {
    return transcript?.id === event.transcriptionId;
  },
} as const;
